import { call, put, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { updateInterviewApi } from "../../API/API";

function* updateInterviewSaga(params) {
    try {
        console.log('update interview saga', params)
        const response = yield call(updateInterviewApi, params);

        yield put({ type: types.UPDATE_INTERVIEW_SUCCESS, payload: response.data });
    }
    catch (error) {
        yield put({ type: types.UPDATE_INTERVIEW_FAILURE, error });
    }
}

export function* watchUpdateInterviewSaga() {
    yield takeLeading(types.UPDATE_INTERVIEW_REQUESTED, updateInterviewSaga);
}
